export enum AuthenticationStatus {
    Authorized = 1,
    NotAuthorized = 2,
    Inactive = 3,
    Authorizing = 4,
    Error = 5,
    NoStoresAssigned = 6,
    Loading = 7
}

export enum ItemAttributeType {
    Boolean = 'BOOL',
    Date = 'DATE',
    DateRange = 'DATERANGE',
    MultiSelect = 'MULTI_SELECT',
    Number = 'NUM',
    Select = 'SELECT',
    Text = 'TEXT',
    TextArea = 'TEXTAREA',
    Image = 'IMAGE'
}
